import { staticText } from './staticText.js';

export const getTranslation = (page, text, localParamLanguage = null) => {
  const savedLanguage = localParamLanguage
    ? localParamLanguage
    : localStorage.getItem('selectedLanguage') || 'id';

  const translation = staticText.find(
    (item) => item.page.toLocaleLowerCase() === page.toLocaleLowerCase()
  );

  let translatedText;

  if (translation) {
    const label = translation.label.find(
      (item) => item.label_id.toLocaleLowerCase() === text.toLocaleLowerCase()
    );
    if (label) {
      translatedText = label[`label_${savedLanguage}`] || label.label_id;
      return translatedText;
    }
  }

  for (const item of staticText) {
    if (item.page !== page) {
      const label = item.label.find(
        (lbl) => lbl.label_id.toLocaleLowerCase() === text.toLocaleLowerCase()
      );
      if (label) {
        translatedText = label[`label_${savedLanguage}`] || label.label_id;
        return translatedText;
      }
    }
  }
  if (translatedText) return translatedText;
  return text;
};
